import { type ErrorLike } from '@apollo/client';
import { useToast } from 'app-ui/components';
import { useCallback } from 'react';

import { getToastOptionsFromError } from '@/apollo/utils/getToastOptionsFromError';
import { captureUnexpectedError } from '@/error-reporting/utils/captureUnexpectedError';
import { isSignedOutState } from '@/session/states/isSignedOutState';
import { useSetAtomState } from '@/ui/utilities/state/jotai/hooks/useSetAtomState';

// What the error link does in the app, shared with the test providers so
// tests go through the same behaviour.
export const useApolloErrorHandlers = () => {
  const { enqueueToast } = useToast();
  const setIsSignedOut = useSetAtomState(isSignedOutState);

  const handleUnauthenticated = useCallback(() => {
    setIsSignedOut(true);
  }, [setIsSignedOut]);

  const handleUnexpectedError = useCallback(
    (error: ErrorLike) => {
      enqueueToast(getToastOptionsFromError({ error }));
      captureUnexpectedError(error);
    },
    [enqueueToast],
  );

  return { handleUnauthenticated, handleUnexpectedError };
};
